module.exports = __webpack_public_path__ + "img/10pica.b208cd7f.png";